console.log('cart.js initiated');

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

function updateShippingMessage(cartTotal, container) {
  const freeShippingThreshold = 6000; // $600.00 in cents
  const shippingWrapper = container.querySelector('.totals--shipping');
  if (!shippingWrapper) return;
  
  const shippingMessage = shippingWrapper.querySelector('.totals__total-value');
  if (shippingMessage) {
    if (cartTotal >= freeShippingThreshold) {
      shippingMessage.textContent = 'Free';
    } else {
      shippingMessage.textContent = 'Calculated at checkout';
    }
  }
}

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    // const inputValue = parseInt(event.target.value);
    // const index = event.target.dataset.index;
    // let message = '';

    // // Special handling for zero quantity (remove item)
    // if (inputValue === 0) {
    //   // Skip validation for removal
    //   this.updateQuantity(
    //     index,
    //     0,
    //     event,
    //     document.activeElement.getAttribute('name'),
    //     event.target.dataset.quantityVariantId
    //   );
    //   return;
    // }

    // // Rest of validation logic...
    // if (inputValue < event.target.dataset.min) {
    //   message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    // } else if (inputValue > parseInt(event.target.max)) {
    //   message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    // } else if (inputValue % parseInt(event.target.step) !== 0) {
    //   message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    // }

    // if (message) {
    //   this.setValidity(event, index, message);
    // } else {
    //   event.target.setCustomValidity('');
    //   event.target.reportValidity();
    //   this.updateQuantity(
    //     index,
    //     inputValue,
    //     event,
    //     document.activeElement.getAttribute('name'),
    //     event.target.dataset.quantityVariantId
    //   );
    // }
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    const variantId = event.target.dataset.quantityVariantId;
    let message = '';

    // Special handling for zero quantity (remove item)
    if (inputValue === 0) {
      // Skip validation for removal
      this.updateQuantity(
        index,
        0,
        event,
        document.activeElement.getAttribute('name'),
        variantId
      );
      return;
    }

    console.log('we are here');

    // Check if input has max (inventory constraint)
    const maxAvailable = parseInt(event.target.max);
    
    // Check various conditions
    if (inputValue < event.target.dataset.min) {
      // message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (maxAvailable && inputValue > maxAvailable) {
      // message = `Sorry, only ${maxAvailable} ${maxAvailable === 1 ? 'item' : 'items'} available`;
    } else if (inputValue > parseInt(event.target.max)) {
      // message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      // message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        variantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    console.log('onCartUpdate called for', this.tagName);
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'CartMain',
        section: 'cart',
        selector: '.cart-wrapper__inner',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    // Store recently viewed tab state before update
    const cartDrawer = this.closest('cart-drawer');
    let recentlyViewedState = null;
    
    if (cartDrawer) {
      recentlyViewedState = cartDrawer.saveRecentlyViewedState();
    }
    
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        if (!response.ok) {
          return response.json().then(errorData => {
            throw new Error(errorData.description || 'Could not update item quantity');
          });
        }
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        console.log('parsedState', parsedState);
        // Check if there was an error with the request
        if (parsedState.status === 422) {
          // This is an inventory constraint error
          throw new Error(parsedState.description || 'You\'ve reached the maximum quantity for this item.');
        }

        if (parsedState.errors?.length > 0) {
          // This is an inventory constraint error
          throw new Error(parsedState.description || 'You\'ve reached the maximum quantity for this item.');
        }

	      // updateShippingMessage(parsedState.total_price, document.querySelector('cart-drawer') || document);
        
        // Check if we're transitioning from empty to non-empty cart
        const wasEmpty = document.querySelector('cart-drawer')?.classList.contains('is-empty');
        const nowEmpty = parsedState.item_count === 0;
        
        // Update empty state classes
        this.classList.toggle('is-empty', nowEmpty);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', nowEmpty);
        if (cartDrawerWrapper) {
          cartDrawerWrapper.classList.toggle('is-empty', nowEmpty);
        }

        // CRITICAL FIX: For empty-to-items transition, do a complete refresh
        if (wasEmpty && !nowEmpty && cartDrawerWrapper) {
          // Force a complete reload of the cart drawer
          fetch(`${routes.cart_url}?section_id=cart-drawer`)
            .then(response => response.text())
            .then(html => {
              // Parse the returned HTML
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              
              // Get the drawer inner HTML to replace
              const newDrawerInner = doc.querySelector('.drawer__inner');
              const currentDrawerInner = cartDrawerWrapper.querySelector('.drawer__inner');
              
              if (newDrawerInner && currentDrawerInner) {
                // Replace the entire inner content
                currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
                
                // Re-initialize cart drawer after replacement
                cartDrawerWrapper.initCartDrawerAfterUpdate(recentlyViewedState);
                
                // Ensure recently viewed buttons work
                if (typeof window.initQuickAddButtons === 'function') {
                  window.initQuickAddButtons(cartDrawerWrapper);
                }
              }
            })
            .catch(error => {
              console.error("Error refreshing cart drawer:", error);
            });
          return; // Skip the rest of the update process
        }

        // For normal updates, continue with regular section updates
        this.getSectionsToRender().forEach((section) => {
          // Skip if not on cart page and trying to update cart page
          if (section.id === 'CartMain' && !document.getElementById('CartMain')) return;

          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');
        
        if (quantityElement && items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        // Restore recently viewed tab state after cart update
        if (cartDrawer && recentlyViewedState) {
          setTimeout(() => {
            cartDrawer.restoreRecentlyViewedState(recentlyViewedState);
          }, 0);
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(e => {
        console.error(e);
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        // Enhanced error handling
        // Enhanced error handling
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) {
          // Display a more helpful message
          errors.textContent = e.message || window.cartStrings.error;
          errors.classList.add('cart-errors--visible');
          
          // Auto-hide after 5 seconds
          setTimeout(() => {
            errors.classList.remove('cart-errors--visible');
          }, 5000);
        }
        
        // Update cart to reflect actual state
        window.refreshCart(false); // Don't open drawer
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  refreshCartWithValidQuantities() {
    // Fetch current cart state to get valid quantities
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update quantity inputs to match the server state
        cart.items.forEach((item, index) => {
          console.log('item', item);
          console.log('item.variant_inventory_quantity', item.variant_inventory_quantity);
          console.log('index', index);
          const quantityInput = document.querySelector(`#Quantity-${index + 1}`) || 
                              document.querySelector(`#Drawer-quantity-${index + 1}`);
          if (quantityInput) {
            quantityInput.value = item.quantity;
            
            // Update max attribute based on inventory
            if (item.variant_inventory_quantity) {
              quantityInput.setAttribute('max', item.variant_inventory_quantity);
            }
            
            // Add low stock warning if needed
            const cartItem = quantityInput.closest('.cart-item');
            if (cartItem && item.variant_inventory_quantity && item.variant_inventory_quantity <= 5) {
              let stockWarning = cartItem.querySelector('.cart-item__inventory-warning');
              if (!stockWarning) {
                stockWarning = document.createElement('div');
                stockWarning.classList.add('cart-item__inventory-warning');
                cartItem.querySelector('.cart-item__details').appendChild(stockWarning);
              }
              // stockWarning.textContent = `Only ${item.variant_inventory_quantity} left in stock`;
            }
          }
        });
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    setTimeout(() => {
      // Empty timeout for animation purposes
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

function directSwitchToCartTab(drawer) {
  // Get tab elements
  console.log('Directly switching to cart tab');
  const cartTab = drawer.querySelector('.drawer__tab--cart');
  const cartContent = drawer.querySelector('.drawer__tab-content--cart');
  const allTabs = drawer.querySelectorAll('.drawer__tab');
  const allContent = drawer.querySelectorAll('.drawer__tab-content');
  
  if (cartTab && cartContent) {
    // Force all tabs inactive
    allTabs.forEach(tab => tab.classList.remove('active'));
    allContent.forEach(content => content.classList.remove('active'));
    
    // Force cart tab active
    cartTab.classList.add('active');
    cartContent.classList.add('active');
    
    console.log('Cart tab directly activated');
  }
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Store initial recently viewed count
    const recentlyViewed = JSON.parse(localStorage.getItem('recently_viewed') || '[]');
    this.initialRecentlyViewedCount = Math.min(recentlyViewed.length, 10);
    
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    this.setHeaderCartIconAccessibility();
    
    // Track the recently viewed tab state
    this.recentlyViewedTabVisible = false;
    this.shouldSwitchToCartTab = false;
    
    // Initialize drawer after DOM is fully loaded
    this.initCartDrawer();
    
    // Listen for cart updates from recently-viewed
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'recently-viewed') {
        // Switch to cart tab after update
        setTimeout(() => this.switchToCartTab(), 100);
      }
    });

    this.cartUpdateListener = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // After any cart update, check if we need to reinitialize buttons
      setTimeout(() => {
        // Reinitialize buttons in the recently viewed tab
        const container = this.querySelector('.drawer__recently-viewed-products-wrapper');
        if (container) {
          if (typeof window.initQuickAddButtons === 'function') {
            window.initQuickAddButtons(container);
          } else {
            this.initQuickAddButtons(container);
          }
        }
        
        // Check if we should switch to cart tab
        if (this.shouldSwitchToCartTab) {
          this.switchToCartTab();
          this.shouldSwitchToCartTab = false;
        }
      }, 200);
    });

    // Add this new code for initialization after DOM is fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.initializeQuickAddButtons();
      });
    } else {
      // DOM already loaded
      setTimeout(() => this.initializeQuickAddButtons(), 100);
    }
  }

  initializeQuickAddButtons() {
    const container = this.querySelector('.drawer__recently-viewed-products-wrapper');
    console.log('Initializing quick add buttons in cart drawer:', container);
    if (container) {
      this.initQuickAddButtons(container);
    }
  }

  directSwitchToCartTab() {
    console.log('Directly switching to cart tab');
    const cartTab = this.querySelector('.drawer__tab--cart');
    const cartContent = this.querySelector('.drawer__tab-content--cart');
    
    if (cartTab && cartContent) {
      this.querySelectorAll('.drawer__tab').forEach(t => t.classList.remove('active'));
      this.querySelectorAll('.drawer__tab-content').forEach(c => c.classList.remove('active'));
      
      cartTab.classList.add('active');
      cartContent.classList.add('active');
      
      console.log('Cart tab directly activated');
    }
  }
  
  // Clean up event listeners when component is removed
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    if (this.cartUpdateListener) {
      this.cartUpdateListener();
    }
  }
  
  initCartDrawer() {
    // Set up overlay click listener
    const overlayElement = document.querySelector('.content-overlay');
    if (overlayElement) {
      overlayElement.addEventListener('click', this.close.bind(this));
    }
    
    // Set up close button listener
    const closeButton = this.querySelector('.drawer__close');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }
    
    // Initialize tabs
    this.initTabs();
    
    // Check if we should load recently viewed products
    this.checkRecentlyViewedProducts();
    
    // When clicking continue shopping button close the cart drawer
    const continueShoppingButtons = this.querySelectorAll('.cart__continue-button');
    continueShoppingButtons.forEach((button) => {
      button.addEventListener('click', e => {
        e.preventDefault();
        this.close();
      });
    });
  }
  
  // Method to reinitialize the cart drawer after content update
  initCartDrawerAfterUpdate(recentlyViewedState) {
    // Re-initialize event listeners
    const closeButton = this.querySelector('.drawer__close');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }
    
    const continueShoppingButtons = this.querySelectorAll('.cart__continue-button');
    continueShoppingButtons.forEach((button) => {
      button.addEventListener('click', e => {
        e.preventDefault();
        this.close();
      });
    });
    
    // Re-initialize tabs
    this.initTabs();
    
    // Restore recently viewed state
    if (recentlyViewedState) {
      this.restoreRecentlyViewedState(recentlyViewedState);
    } else {
      // Otherwise just make sure the tab is visible if needed
      this.checkRecentlyViewedProducts();
    }
  }

  onCartUpdate() {
    return fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        // Save recently viewed state before update
        const recentlyViewedState = this.saveRecentlyViewedState();
        
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const drawerInner = this.querySelector('.drawer__inner');
        const sourceInner = html.querySelector('.drawer__inner');
        
        if (drawerInner && sourceInner) {
          // Complete replacement of drawer inner content
          drawerInner.innerHTML = sourceInner.innerHTML;
          
          // Re-initialize cart drawer
          this.initCartDrawerAfterUpdate(recentlyViewedState);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  // Save the state of the recently viewed tab for restoration after cart update
  saveRecentlyViewedState() {
    const recentlyViewedTab = this.querySelector('.drawer__tab--recently-viewed');
    if (!recentlyViewedTab) return null;
    
    return {
      visible: !recentlyViewedTab.classList.contains('hidden'),
      active: recentlyViewedTab.classList.contains('active'),
      content: this.querySelector('.drawer__recently-viewed-products-wrapper')?.innerHTML || '',
      loaded: this.querySelector('.drawer__recently-viewed-products-wrapper')?.hasAttribute('data-loaded') || false
    };
  }

  // Restore the recently viewed tab state after cart update
  restoreRecentlyViewedState(state) {
    if (!state) return;
    
    const recentlyViewedTab = this.querySelector('.drawer__tab--recently-viewed');
    if (!recentlyViewedTab) return;
    
    // Restore visibility
    if (state.visible) {
      recentlyViewedTab.classList.remove('hidden');
      this.recentlyViewedTabVisible = true;
    }
    
    // Restore count - always use the initial count
    if (this.initialRecentlyViewedCount > 0) {
      let countElement = recentlyViewedTab.querySelector('.drawer__tab-count');
      if (!countElement) {
        const countSpan = document.createElement('span');
        countSpan.className = 'drawer__tab-count';
        countSpan.textContent = this.initialRecentlyViewedCount;
        recentlyViewedTab.appendChild(countSpan);
      } else {
        countElement.textContent = this.initialRecentlyViewedCount;
      }
    }
    
    // Restore active state if it was active
    if (state.active) {
      this.querySelectorAll('.drawer__tab').forEach(tab => tab.classList.remove('active'));
      this.querySelectorAll('.drawer__tab-content').forEach(content => content.classList.remove('active'));
      
      recentlyViewedTab.classList.add('active');
      const contentElement = this.querySelector('.drawer__tab-content--recently-viewed');
      if (contentElement) {
        contentElement.classList.add('active');
      }
    }
    
    // Restore content if it was loaded
    const contentWrapper = this.querySelector('.drawer__recently-viewed-products-wrapper');
    if (contentWrapper && state.loaded) {
      contentWrapper.setAttribute('data-loaded', 'true');
      if (state.content) {
        contentWrapper.innerHTML = state.content;
      }
    }
    
    // Re-initialize quick add buttons
    if (typeof window.initQuickAddButtons === 'function') {
      setTimeout(() => window.initQuickAddButtons(this), 100);
    } else {
      setTimeout(() => this.initQuickAddButtons(this), 100);
    }
    
    // Re-initialize tabs
    this.initTabs();
    
    // Switch to cart tab if needed
    if (this.shouldSwitchToCartTab) {
      this.switchToCartTab();
      this.shouldSwitchToCartTab = false;
    }
  }

  initTabs() {
    const tabs = this.querySelectorAll('.drawer__tab');
    if (!tabs.length) return;
    
    // Remove existing event listeners
    tabs.forEach(tab => {
      const clone = tab.cloneNode(true);
      tab.parentNode.replaceChild(clone, tab);
    });
    
    // Add new event listeners
    this.querySelectorAll('.drawer__tab').forEach(tab => {
      tab.addEventListener('click', () => {
        const tabName = tab.getAttribute('data-tab');
        
        // Update active classes
        this.querySelectorAll('.drawer__tab').forEach(t => t.classList.remove('active'));
        this.querySelectorAll('.drawer__tab-content').forEach(c => c.classList.remove('active'));
        
        tab.classList.add('active');
        const contentElement = this.querySelector(`.drawer__tab-content--${tabName}`);
        if (contentElement) {
          contentElement.classList.add('active');
        }
        
        // Load content for recently viewed tab if needed
        if (tabName === 'recently-viewed') {
          this.loadRecentlyViewedProducts();
          
          // Always reinitialize buttons when switching to this tab
          const container = this.querySelector('.drawer__recently-viewed-products-wrapper');
          if (container) {
            setTimeout(() => this.initQuickAddButtons(container), 100);
          }
        }
      });
    });
  }

  checkRecentlyViewedProducts() {
    // Use the stored initial count instead of recalculating
    if (this.initialRecentlyViewedCount > 0) {
      const recentlyViewedTab = this.querySelector('.drawer__tab--recently-viewed');
      if (recentlyViewedTab) {
        recentlyViewedTab.classList.remove('hidden');
        
        // Set counter with initial value (only once)
        if (!recentlyViewedTab.querySelector('.drawer__tab-count')) {
          const countSpan = document.createElement('span');
          countSpan.className = 'drawer__tab-count';
          countSpan.textContent = this.initialRecentlyViewedCount;
          recentlyViewedTab.appendChild(countSpan);
        } else {
          // Ensure counter is always the same as initial
          recentlyViewedTab.querySelector('.drawer__tab-count').textContent = this.initialRecentlyViewedCount;
        }
        
        this.recentlyViewedTabVisible = true;
      }
    }
  }

  isVariantInCart(variantId) {
    const cartItems = Array.from(this.querySelectorAll('.cart-item input.quantity__input'));
    return cartItems.some(input => input.getAttribute('data-quantity-variant-id') === variantId.toString());
  }

  loadRecentlyViewedProducts() {
    const container = this.querySelector('.drawer__recently-viewed-products-wrapper');
    if (!container) return;
    
    // If already loaded, just update button states
    if (container.hasAttribute('data-loaded')) {
      this.updateRecentlyViewedButtonStates();
      return;
    }
    
    // Get recently viewed products
    let recentlyViewed = JSON.parse(localStorage.getItem('recently_viewed') || '[]');
    if (recentlyViewed.length === 0) {
      container.innerHTML = '<p class="empty-state">No recently viewed products</p>';
      return;
    }
    
    // Remove current product if on product page
    const currentPath = window.location.pathname;
    if (currentPath.includes('/products/')) {
      const currentHandle = currentPath.split('/products/')[1].split('?')[0];
      recentlyViewed = recentlyViewed.filter(handle => handle !== currentHandle);
    }
    
    // Get first 4 products - this ensures we match our counter
    const productHandles = recentlyViewed.slice(0, 10);
    this.initialRecentlyViewedCount = productHandles.length; // Update counter to match actual display
    
    // Update the counter display to match
    const recentlyViewedTab = this.querySelector('.drawer__tab--recently-viewed');
    if (recentlyViewedTab) {
      const countElement = recentlyViewedTab.querySelector('.drawer__tab-count');
      if (countElement) {
        countElement.textContent = this.initialRecentlyViewedCount;
      }
    }

    // Mark as loaded
    container.setAttribute('data-loaded', 'true');
    
    try {
      container.innerHTML = '<p class="loading">Loading products...</p>';
      
      // Fetch products in parallel
      const productPromises = productHandles.map(handle => 
        fetch(`${window.Shopify.routes.root}products/${handle}.js`)
          .then(response => response.json())
          .catch(error => {
            console.error(`Failed to fetch product ${handle}:`, error);
            return null;
          })
      );
      
      Promise.all(productPromises).then(products => {
        const validProducts = products.filter(p => p !== null);
        
        if (validProducts.length > 0) {
          container.innerHTML = '';
          
          validProducts.forEach(product => {
            const isOptical = product.type === 'Opticals';
            const isInCart = this.isVariantInCart(product.variants[0].id);
            
            const productEl = document.createElement('div');
            productEl.className = 'drawer__recently-viewed-product';
            
            productEl.innerHTML = `
              <div class="drawer__recently-viewed-product-image">
              <a href="/products/${product.handle}">
              <img src="${product.featured_image || product.images[0]}" alt="${product.title}" loading="lazy">
              </a>
              </div>
              <div class="drawer__recently-viewed-product-info">
              <h3 class="h3 drawer__recently-viewed-product-title">
              <a href="/products/${product.handle}">${product.title}</a>
              </h3>
              ${!isOptical ? 
              `<div class="drawer__recently-viewed-product-price price">
              ${this.formatMoney(product.price)}
              </div>` : 
              ''
              }
              </div>
              ${!isOptical ? 
              (product.available ? 
              `<button 
              class="button button--secondary drawer__recently-viewed-product-add${isInCart ? ' added' : ''}" 
              data-quick-add
              data-product-id="${product.id}" 
              data-variant-id="${product.variants[0].id}"
              ${isInCart ? 'disabled' : ''}
              >
              <svg class="icon icon-plus" xmlns="http://www.w3.org/2000/svg" width="16" height="19" viewBox="0 0 16 19" fill="none">
                <path class="icon-plus__horizontal" d="M7.42746 8.55261H1.14174H0.570312V9.69296H1.14174H7.42746H8.57031H14.856H15.4275V8.55261H14.856H8.57031H7.42746Z" fill="inherit"/>
                <path class="icon-plus__vertical" d="M8.57031 8.55136L8.57031 2.26564L8.57031 1.69421L7.42996 1.69421L7.42996 2.26564L7.42996 8.55136L7.42996 9.69421L7.42996 15.9799L7.42996 16.5514L8.57031 16.5514L8.57031 15.9799L8.57031 9.69421L8.57031 8.55136Z" fill="inherit"/>
              </svg>
              <span class="button__text">
                Add
              </span>
              <span class="button__text--added">
                Added
              </span>
              </button>` : 
              `<a href="/products/${product.handle}" class="button button--secondary drawer__recently-viewed-product-sold-out">
              Notify me
              </a>`
              ) : 
              '' // No button for optical products
              }
            `;
            
            container.appendChild(productEl);
          });
          
          setTimeout(() => {
            if (typeof window.initQuickAddButtons === 'function') {
              window.initQuickAddButtons(container);
            } else {
              this.initQuickAddButtons(container);
            }
          }, 100);
        } else {
          container.innerHTML = '<p class="empty-state">No recently viewed products</p>';
        }
      });
    } catch (error) {
      console.error('Error loading recently viewed products:', error);
      container.innerHTML = '<p class="empty-state">Unable to load recently viewed products</p>';
    }
  }

  initQuickAddButtons(container) {
    // Clear any existing initialized flags first
    container.querySelectorAll('[data-quick-add][data-quick-add-initialized]').forEach(button => {
      button.removeAttribute('data-quick-add-initialized');
    });
    
    // Use the global function from theme.js
    if (typeof window.initQuickAddButtons === 'function') {
      window.initQuickAddButtons(container);
    }
  }

  switchToCartTab() {
    console.log('Switching to cart tab');
    const cartTab = this.querySelector('.drawer__tab--cart');
    const cartContent = this.querySelector('.drawer__tab-content--cart');
    
    if (cartTab && cartContent) {
      // Force removal of active class from all tabs and content
      const allTabs = this.querySelectorAll('.drawer__tab');
      const allContent = this.querySelectorAll('.drawer__tab-content');
      
      allTabs.forEach(t => t.classList.remove('active'));
      allContent.forEach(c => c.classList.remove('active'));
      
      // Force cart tab to be active
      cartTab.classList.add('active');
      cartContent.classList.add('active');
      
      // Log success
      console.log('Cart tab activated');
      
      // Reset flag
      this.shouldSwitchToCartTab = false;
    } else {
      console.warn('Could not find cart tab elements');
    }
  }

  updateRecentlyViewedButtonStates() {
    const buttons = this.querySelectorAll('.drawer__recently-viewed-product-add');
    
    buttons.forEach(button => {
      const variantId = button.getAttribute('data-variant-id');
      const isInCart = this.isVariantInCart(variantId);
      
      if (isInCart && !button.classList.contains('added')) {
        button.classList.add('added');
        // const buttonText = button.querySelector('.button__text');
        // if (buttonText) buttonText.textContent = 'Added';
        button.disabled = true;
      } else if (!isInCart && button.classList.contains('added')) {
        button.classList.remove('added');
        // const buttonText = button.querySelector('.button__text');
        // if (buttonText) buttonText.textContent = 'Add';
        button.disabled = false;
      }
    });
  }

  formatMoney(cents) {
    return '€' + (parseFloat(cents) / 100).toFixed(2);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    
    // Check for cart drawer note
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }
    
    // Make sure recently viewed tab is shown if we have products
    this.checkRecentlyViewedProducts();
    
    // Trigger animation
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        // trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('overlay-open');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('overlay-open');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    // Save recently viewed state
    const recentlyViewedState = this.saveRecentlyViewedState();
    
    // Update drawer contents
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // After content update
    setTimeout(() => {
      // Re-initialize the drawer
      this.initCartDrawerAfterUpdate(recentlyViewedState);
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (selector == ".cart-wrapper__inner") {
      if (!document.getElementById('CartMain')) return '';
    }
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'CartMain',
        section: 'cart',
        selector: '.cart-wrapper__inner',
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'CartMain',
        section: 'cart',
        selector: '.cart-wrapper__inner',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Global refreshCart function
window.refreshCart = function(showDrawer = true) {
  console.log('Refreshing cart...');
  
  const isCartPage = window.location.pathname.includes('/cart') || 
                    document.querySelector('.cart-wrapper') !== null;
  
  const cartDrawer = document.querySelector('cart-drawer');
  let recentlyViewedState = null;
  
  if (cartDrawer) {
    recentlyViewedState = cartDrawer.saveRecentlyViewedState();
  }
  
  // Get cart data
  fetch('/cart.js')
    .then(response => response.json())
    .then(cartData => {
      const updatePromises = [];
      
      // Update cart drawer
      if (cartDrawer) {
        const drawerPromise = fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then(response => response.text())
          .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            
            // Check if we're transitioning from empty to non-empty cart
            const wasEmpty = cartDrawer.classList.contains('is-empty');
            const nowEmpty = cartData.item_count === 0;
            
            // For empty to non-empty transition, do a complete update
            if (wasEmpty && !nowEmpty) {
              const drawerInner = cartDrawer.querySelector('.drawer__inner');
              const newDrawerInner = html.querySelector('.drawer__inner');
              
              if (drawerInner && newDrawerInner) {
                // Complete replacement
                drawerInner.innerHTML = newDrawerInner.innerHTML;
                
                // Ensure empty class is removed
                cartDrawer.classList.remove('is-empty');
                
                // Re-initialize
                cartDrawer.initCartDrawerAfterUpdate(recentlyViewedState);
              }
            } else {
              // Normal update
              // Update cart items content
              const cartItemsWrapper = cartDrawer.querySelector('.drawer__cart-items-wrapper');
              const newCartItemsWrapper = html.querySelector('.drawer__cart-items-wrapper');
              if (cartItemsWrapper && newCartItemsWrapper) {
                cartItemsWrapper.innerHTML = newCartItemsWrapper.innerHTML;
              }
              
              // Update subtotal
              const subtotal = cartDrawer.querySelector('#cart-drawer-subtotal');
              const newSubtotal = html.querySelector('#cart-drawer-subtotal');
              if (subtotal && newSubtotal) {
                subtotal.textContent = newSubtotal.textContent;
              }

              // //check if price is over free shipping threshold
              // const freeShippingThreshold = 60000; // Example threshold in cents
              // console.log('Cart subtotal:', cartData.total_price);
              // if (new Subtotal > freeShippingThreshold) {
              //   const shippingWrapper = cartDrawer.querySelector('.totals--shipping');
              //   const shippingMessage = shippingWrapper.querySelector('.totals__total-value');
              //   if (shippingMessage) {
              //     console.log('Free shipping qualified');
              //     shippingMessage.textContent = 'You have qualified for free shipping!';
              //   }
              // }

              // updateShippingMessage(cartData.total_price, document.querySelector('cart-drawer') || document);
              
              // Update empty state
              const drawerInner = cartDrawer.querySelector('.drawer__inner');
              if (drawerInner) {
                drawerInner.classList.toggle('is-empty', cartData.item_count === 0);
                cartDrawer.classList.toggle('is-empty', cartData.item_count === 0);
              }
              
              // Update cart item count
              const cartTab = cartDrawer.querySelector('.drawer__tab--cart');
              if (cartTab) {
                let countElement = cartTab.querySelector('#cart-drawer-item-count');
                
                if (cartData.item_count > 0) {
                  if (!countElement) {
                    const headingElement = cartTab.querySelector('#cart-drawer-heading');
                    if (headingElement) {
                      headingElement.insertAdjacentHTML('afterend', 
                        `<span class="drawer__heading--item-count" id="cart-drawer-item-count">${cartData.item_count}</span>`);
                    } else {
                      cartTab.insertAdjacentHTML('beforeend', 
                        `<span class="drawer__heading--item-count" id="cart-drawer-item-count">${cartData.item_count}</span>`);
                    }
                  } else {
                    countElement.textContent = cartData.item_count;
                  }
                } else if (countElement) {
                  countElement.remove();
                }
              }
              
              // Restore recently viewed state
              if (recentlyViewedState) {
                setTimeout(() => {
                  cartDrawer.restoreRecentlyViewedState(recentlyViewedState);

                  // Ensure quick add buttons are reinitialized
                  if (cartDrawer) {
                    const container = cartDrawer.querySelector('.drawer__recently-viewed-products-wrapper');
                    if (container) {
                      setTimeout(() => {
                        cartDrawer.initQuickAddButtons(container);
                        
                        // Check if we should switch tabs
                        if (cartDrawer.shouldSwitchToCartTab) {
                          cartDrawer.switchToCartTab();
                          cartDrawer.shouldSwitchToCartTab = false;
                        }
                      }, 100);
                    }
                  }
                }, 0);
              }
            }

            // Ensure quick add buttons are reinitialized
            if (cartDrawer) {
              // Check if we should switch to cart tab
              if (cartDrawer.shouldSwitchToCartTab) {
                setTimeout(() => {
                  cartDrawer.switchToCartTab();
                }, 100);
              }
              
              // Reinitialize buttons if the recently viewed tab is active
              const recentlyViewedTab = cartDrawer.querySelector('.drawer__tab--recently-viewed.active');
              if (recentlyViewedTab) {
                const container = cartDrawer.querySelector('.drawer__recently-viewed-products-wrapper');
                if (container) {
                  setTimeout(() => cartDrawer.initQuickAddButtons(container), 100);
                }
              }
            }

            if (cartDrawer) {
              const container = cartDrawer.querySelector('.drawer__recently-viewed-products-wrapper');
              if (container) {
                setTimeout(() => {
                  if (typeof window.initQuickAddButtons === 'function') {
                    window.initQuickAddButtons(container);
                  }
                }, 200);
              }
            }
            
            // Open drawer if needed
            if (showDrawer && !(isCartPage && document.activeElement?.hasAttribute('data-quick-add'))) {
              setTimeout(() => cartDrawer.open(), 10);
            }
          });
        
        updatePromises.push(drawerPromise);
      }
      
      // Update main cart if on cart page
      if (isCartPage) {
        const cartPagePromise = fetch(window.location.href)
          .then(response => response.text())
          .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            
            // Update cart items
            const mainCartItems = document.getElementById('main-cart-items');
            if (mainCartItems) {
              const sourceItems = html.querySelector('#main-cart-items');
              if (sourceItems) {
                mainCartItems.innerHTML = sourceItems.innerHTML;
              }
            }
            
            // Update cart summary
            const cartSummary = document.querySelector('.cart__summary');
            if (cartSummary) {
              const sourceSummary = html.querySelector('.cart__summary');
              if (sourceSummary) {
                cartSummary.innerHTML = sourceSummary.innerHTML;
              }
            }
          });
        
        updatePromises.push(cartPagePromise);
      }
      
      // Complete updates
      Promise.all(updatePromises)
        .then(() => {
          // Reinitialize quantity inputs
          if (isCartPage) {
            document.querySelectorAll('quantity-input').forEach(input => {
              if (typeof input.validateQtyRules === 'function') {
                input.validateQtyRules();
              }
            });
          }
          
          // Publish cart update event
          publish(PUB_SUB_EVENTS.cartUpdate, { 
            source: 'refresh-cart',
            cartData: cartData
          });
        })
        .catch(error => {
          console.error('Error updating cart:', error);
          publish(PUB_SUB_EVENTS.cartUpdate, { 
            source: 'refresh-cart',
            cartData: cartData
          });
        });
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
};

// Global open/close cart functions
window.openCart = function() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.open();
  }
};

window.closeCart = function() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.close();
  }
};

// Initialize cart functionality on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  // Cart initialization is handled by the web components themselves
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.cartData) {
      // Update drawer shipping message
      const cartDrawer = document.querySelector('cart-drawer');
      updateRelatedProductButtonState(event.cartData);
      if (cartDrawer) {
        // updateShippingMessage(event.cartData.total_price, cartDrawer);
      }
      
      // Update cart page shipping message
      const cartPage = document.querySelector('.cart-wrapper');
      if (cartPage) {
        // updateShippingMessage(event.cartData.total_price, cartPage);
      }
    }
  });

  // Initial state check on page load
  fetch('/cart.js')
    .then(response => response.json())
    .then(cartData => {
      updateRelatedProductButtonState(cartData);
    })
    .catch(error => {
      console.error('Error fetching initial cart data for related product:', error);
    });
});

// Function to update related product button state when cart changes
function updateRelatedProductButtonState(cartData) {
  // Only run on product pages
  if (!window.location.pathname.includes('/products/')) return;
  
  // Find the related product button
  const relatedProductButton = document.querySelector('.related-product .button');
  if (!relatedProductButton) return;
  
  // Get the variant ID from the button
  const variantId = relatedProductButton.getAttribute('data-variant-id');
  if (!variantId) return;
  
  // Check if this variant is in the cart
  const isInCart = cartData?.items?.some(item => item.variant_id.toString() === variantId);
  
  // Update button state
  if (isInCart && !relatedProductButton.classList.contains('added')) {
    relatedProductButton.classList.add('added');
    relatedProductButton.disabled = true;
    
    // Update text if there's a text element
    const buttonText = relatedProductButton.querySelector('.button__text');
    if (buttonText) buttonText.textContent = 'Added';
  } else if (!isInCart && relatedProductButton.classList.contains('added')) {
    relatedProductButton.classList.remove('added');
    relatedProductButton.disabled = false;
    
    // Update text if there's a text element
    const buttonText = relatedProductButton.querySelector('.button__text');
    if (buttonText) buttonText.textContent = 'Add to cart';
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // Check product availability for quick add buttons
  document.querySelectorAll('[data-quick-add]').forEach(button => {
    const productId = button.getAttribute('data-product-id');
    const variantId = button.getAttribute('data-variant-id');
    
    if (productId && variantId) {
      // Find product handle from URL or data attribute
      let productHandle = button.closest('[data-product-handle]')?.getAttribute('data-product-handle');
      
      if (productHandle) {
        checkProductAvailability(productHandle, variantId);
      }
    }
  });
  
  // Check availability for product form
  const productForm = document.querySelector('form.shopify-product-form');
  if (productForm) {
    const variantId = productForm.querySelector('[name="id"]')?.value;
    const productHandle = document.querySelector('.product')?.getAttribute('data-product-handle') || 
                        window.location.pathname.split('/products/')[1]?.split('?')[0];
    
    if (variantId && productHandle) {
      checkProductAvailability(productHandle, variantId);
    }
  }
});